<template>
  <div>
    <!-- <van-nav-bar title="联系客服" class="" /> -->
    <div class="top-bar">
      <van-row>
        <van-col span="2"></van-col>
        <van-col span="20" style="text-align: center">
          <span class="topTextDesignLeft"> 专属客服 </span>
          <span class="topTextDesignRight" @click="openQchat()">
            在线客服
          </span>
        </van-col>
        <van-col v-model="wonder_chat_notice_sound" span="2">
          <!-- <div style="float: right; text-align: right"> -->
            <!-- <span style="display: inline-block" >--> 
              <!-- <img style="width: 28px" src="../assets/images/sound-on.png"/> -->
            <!-- </span> -->
            <!-- <span style="display: inline-block"> -->
              <!-- <van-switch
                id="switch-btn"
                :active-value="1"
                :inactive-value="0"
                size="24"
                v-model="wonder_chat_notice_sound"
              /> -->
              <img style="width: 20px"  :src="require('../assets/images/'+chatSoundImg)" @click="changeChatSound()"/>
            <!-- </span> -->
          <!-- </div> -->
        </van-col>
      </van-row>
    </div>
    <van-row
      class="rowDesign"
      @click="
        $router.push({ name: 'ChatRoomUser', params: { account: 'system' } })
      "
    >
      <van-col span="4">
        <img src="../assets/images/systemImg.jpg" class="imageStyle" />
      </van-col>
      <van-col span="16" class="userStyle">
        <van-row class="userRowStyle"><span>系统消息</span></van-row>
      </van-col>
      <van-col span="4" style="text-align: right">
        <van-badge
          :content="
            $store.state.system_message_unread > 0
              ? $store.state.system_message_unread
              : ''
          "
          style="padding: 6px 14px; margin-top: 5px"
        />
      </van-col>
    </van-row>
    <div style="">
      <div v-for="i in $store.state.message_list" :key="i.id">
        <van-row
          class="rowDesign"
          @click="
            $router.push({ name: 'ChatRoomUser', params: { account: i.id } })
          "
        >
          <van-col span="4">
            <img src="../assets/images/login_logo.png" class="imageStyle" />
          </van-col>
          <van-col span="16" class="userStyle">
            <van-row class="userRowStyle"
              ><span>{{ i.user.username }}</span></van-row
            >
            <van-row class="messageStyle"
              ><span>{{
                i.messages.length > 0 &&
                i.messages[i.messages.length - 1].format == 0
                  ? i.messages[i.messages.length - 1].content
                  : ""
              }}</span>
            </van-row>
          </van-col>
          <van-col span="4" style="text-align: right">
            <van-badge
              :content="i.unread > 0 ? i.unread : ''"
              style="padding: 6px 14px; margin-top: 5px"
            />
          </van-col>
        </van-row>
      </div>

      <!-- <router-link to="">
        <van-row class="rowDesign">
          <van-col span="4">
            <img src="../assets/images/login_logo.png" class="imageStyle" />
          </van-col>
          <van-col span="20" class="userStyle">
            <van-row class="userRowStyle"><span>Agent2</span></van-row>
            <van-row class="messageStyle"
              ><span
                >你好！ 这里是 天元证券配资系统 我是客服 agent2
                有什么能帮到您的？</span
              ></van-row
            >
          </van-col>
        </van-row>
      </router-link>
      <router-link to="">
        <van-row class="rowDesign">
          <van-col span="4">
            <img src="../assets/images/login_logo.png" class="imageStyle" />
          </van-col>
          <van-col span="20" class="userStyle">
            <van-row class="userRowStyle"><span>{{item.username}}</span></van-row>
            <van-row class="messageStyle"
              ><span
                >你好！ 这里是 天元证券配资系统 我是客服 agent2
                有什么能帮到您的？</span
              ></van-row
            >
          </van-col>
        </van-row>
      </router-link> -->
    </div>
  </div>
</template>

<script>
import { Browser } from "@capacitor/browser";

export default {
  name: "ChatRoom",
  data() {
    return {
      chatSoundImg:'',
      friendArrList: [],
      isMute: 0,
      qserver_url: "",
    };
  },
  computed: {
    wonder_chat_notice_sound: {
       get() {
         let muteStatus = this.$store.state.wonder_chat_notice_sound;
          if(muteStatus == 1){
            this.chatSoundImg = 'sound-on.png'
          }else{
            this.chatSoundImg = 'sound-muted.png'
          }
        // return this.$store.state.wonder_chat_notice_sound;
      },
      set(value) {
        this.$store.commit("updateWonderChatSound", value);
      },
    },   
  },
  methods: {

    changeChatSound(){
      let muteStatus = this.$store.state.wonder_chat_notice_sound;
      if(muteStatus == 1){
        this.$store.commit("updateWonderChatSound", 0);
      }else{
        this.$store.commit("updateWonderChatSound", 1);
      } 
    },
    isLogin() {
      if (!this.$store.state.loginType) {
        this.$router.push("/login");
      }
    },
    setMute() {
      var checkbox = this.isMute;
      if (checkbox == 1) {
        this.voice();
        localStorage.setItem("isMuteMobile", false);
      } else {
        localStorage.setItem("isMuteMobile", true);
      }
    },
    voice() {
      var audio = document.createElement("audio");
      audio.src =
        process.env.WONDER_CHAT_ROOT +
        "/resource/layim/css/modules/layim/voice/default.mp3";
      audio.play();
    },
    get_qchat_server_url() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "server_url",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.qserver_url = data;
            that.$store.commit("chatServerUrl", that.qserver_url);
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    openQchat() {
      if (Capacitor.getPlatform() === "android") {
        //check if android app, if android app use native plugin to open popup
        Browser.open({ url: this.$store.state.chat_server_url });
      } else {
        window.open(this.$store.state.chat_server_url);
      }
    },
  },
  mounted: function () {
    this.isLogin();
    this.get_qchat_server_url();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.rowDesign {
  padding: 4px 10px;
  border-bottom: 1px solid #dcdee0;
}

.imageStyle {
  width: 40px;
  border-radius: 0px;
}

.userStyle {
  text-align: left;
  padding-right: 10px;
}

.userRowStyle {
  padding-top: 3px;
  color: #000000;
}

.messageStyle {
  color: #969799;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

.top-bar {
  background: #ee0a24;
  padding: 13px 11px 10px;
}

.bar-text {
  color: #fff;
  font-size: 14px;
}

#switch-btn {
  font-size: 18px !important;
  float: right;
}

.topTextDesignLeft {
  border: 1px solid #ffffff;
  color: #ffffff;
  padding: 4px 6px 2px;
}

.topTextDesignRight {
  border: 1px solid #ffffff;
  color: #ee0a24;
  padding: 4px 6px 2px;
  background-color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/ChatRoom.vue